import { makeObservable, observable } from 'mobx';

import RoutesPlannerStore from '../routes-planner-store';
import { KpiConfiguration } from '../../components/routes-planner/routes-planner';
import { optimizationKpiFetchService } from '../../services/optimization-kpi/optimization-kpi-fetch-service';

export type BaseOptimizationKpiData = {
	timeFairness: number;
	intersections: number;
};

export type OptimizationKpiData = BaseOptimizationKpiData & {
	assignedCount: number;
	unassignedCount: number;
	totalRoutesDuration: number;
	totalRoutesDistance: number;
	stopsPerHour: number;
};

export type OptimizationKpi = {
	original: OptimizationKpiData;
	manual: OptimizationKpiData;
};
export default class OptimizationKpiStore {
	rootStore: RoutesPlannerStore;
	optimizationKpiData: OptimizationKpi = null;
	kpiConfiguration: KpiConfiguration;
	fetchService;

	constructor(rootStore: RoutesPlannerStore, kpiConfiguration: KpiConfiguration, fetchKpi) {
		makeObservable(this, {
			optimizationKpiData: observable,
			kpiConfiguration: observable
		});
		this.rootStore = rootStore;
		this.kpiConfiguration = kpiConfiguration;

		this.fetchService = optimizationKpiFetchService.init(rootStore, fetchKpi);
	}

	async fetchUpdatedKpiData(withOriginal: boolean) {
		this.optimizationKpiData = await this.fetchService.fetchUpdatedKpiData(withOriginal, this.optimizationKpiData);
	}

	setOptimizationKpiData(data: OptimizationKpi) {
		this.optimizationKpiData = data;
	}
}
